export const SERVER_SPORTS = [
	"tennis",
	"table-tennis",
	"volleyball",
	"beach-volley",
];
